import { Configuration } from '@/types';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import { TreeViewConstants } from '@/types/constants/TreeViewConstants';

const DocumentEncryptionConfigration = () =>
  import(
    /* webpackChunkName: "DocumentEncryptionConfiguration" */
    '@/views/configuration/documentEncryption/DocumentEncryptionConfiguration.vue'
  );
const meta = {
  layout: 'TreeView',
  treePath: '/configuration/documentEncryption',
  treeViewKey: TreeViewConstants.Keys.Configuration,
  title: 'Document Encryption'
};

export const DocumentEncryptionRoutes = [
  {
    ...Configuration.DocumentEncryption.DocumentEncryptionConfiguration,
    components: {
      default: DocumentEncryptionConfigration,
      treeView: ConfigurationTreeView
    },
    meta
  }
];
